import React from 'react'
import { FlexColumn, Text, Card } from 'elements'
import { dateToLocale } from 'utils/date'

type Props = {
  periodStart: string | null
  periodEnd: string | null
}

export default function ReportPeriodCard(props: Props) {
  const { periodStart, periodEnd } = props

  //older upload reports won't have report period
  if (!periodStart || !periodEnd) {
    return null
  }

  return (
    <Card
      width="365px"
      height="265px"
      justifyContent="space-evenly"
      alignItems="center"
      py="xxxlarge"
    >
      <FlexColumn height="100%" justifyContent="space-evenly">
        <Text fontSize="xlarge" fontWeight="bold">
          Report Start:
        </Text>
        <Text fontSize="xlarge" fontWeight="bold">
          Report End:
        </Text>
      </FlexColumn>
      <FlexColumn height="100%" justifyContent="space-evenly">
        <Text fontSize="xlarge">{dateToLocale(periodStart)}</Text>
        <Text fontSize="xlarge">{dateToLocale(periodEnd)}</Text>
      </FlexColumn>
    </Card>
  )
}
